<template>
  <div class="enter-bout">
    <h1>Enter a new bout</h1>
    <boutform v-bind:competitors="competitors" v-bind:events="events" v-bind:me="me"></boutform>
  </div>
</template>

<script>
import boutform from '@/components/Boutform'
import config from '../config'
import { EventBus } from '../main'

export default {
  name: 'enterBout',
  components: {
    boutform
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getData()
    })
  },
  beforeRouteUpdate (to, from, next) {
    next(vm => {
      vm.getData()
    })
  },
  methods : {
    setData(d,d2,d3){
      this.competitors = d
      this.events = d2
      this.me = d3
    },
    getData(){
      return new Promise((resolve, reject) => {
        fetch(config.baseUrl+"competitors/", {
          credentials : "include"
        })
        .then(e => {
          return e.json()
        }).then(j => {
          fetch(config.baseUrl+"events/past/mine/", {
            credentials : "include"
          }).then(e => {
            return e.json()
          }).then(j2 => {
            fetch(config.baseUrl+"user/me/", {
              credentials : "include"
            }).then(e => {
              return e.json()
            }).then(j3 => {
              this.setData(j,j2,j3)
            })
          })
        })
      })
    }
  },
  data () {
    return {
      competitors : {},
      events : {},
      me : {}
    }
  },
  created (){
    this.getData()
    // listen for a new competitor and update the data
    EventBus.$on("newCompetitor", (data) => {
      this.competitors.push(data)
    })
    EventBus.$on("newEvent", (data) => {
      this.events.push(data)
    })
  }
}
</script>
